import { SagaMiddleware } from 'redux-saga';

type Saga = () => Iterator<{}>;
type SagaMap = { [name: string]: Saga | SagaMap };

export function registerSagas(sagaMap: SagaMap, sagaMiddleware: SagaMiddleware<{}>): void {
    // Register sagas
    Object.keys(sagaMap)
        .map(name => sagaMap[name])
        .filter(saga => typeof saga === 'function')
        .forEach((saga: Saga) =>
            sagaMiddleware.run(saga as any)
        );

    // Recurse deeper for nested sagas
    Object.keys(sagaMap)
        .map(name => sagaMap[name])
        .filter(s => typeof s === 'object')
        .forEach((s: SagaMap) => {
            registerSagas(s, sagaMiddleware);
        });
}



// WEBPACK FOOTER //
// ./src/startup/registerSagas.ts